export const RESOURCE_SCREEN_PERMISSION = "MarketplaceResourceConfigure";

export const RESOURCE_ACTION_PERMISSIONS = Object.freeze({
  addClientResource: "MarketplaceClientResourceAdd",
  configureResource: "MarketplaceResourceConfigure",
  manageClientResourceApproval: "ProductMarketplaceClientResourceApproval"
});

export const normalizeNavigationPermissions = (navigation, fallbackPermission = RESOURCE_SCREEN_PERMISSION) => {
  const configuredPermissions = navigation?.permissions
    ?? navigation?.Permissions
    ?? navigation?.permission
    ?? navigation?.Permission;

  if (Array.isArray(configuredPermissions)) {
    const permissions = configuredPermissions
      .map((permission) => String(permission ?? "").trim())
      .filter(Boolean);
    return permissions.length > 0 ? permissions : [fallbackPermission];
  }

  const permission = String(configuredPermissions ?? "").trim();
  return permission ? [permission] : [fallbackPermission];
};

export const canRenderManagedNavigation = (
  navigation,
  { canAccess, canViewOnNav },
  fallbackPermission = RESOURCE_SCREEN_PERMISSION
) => {
  const permissions = normalizeNavigationPermissions(navigation, fallbackPermission);
  return canAccess(permissions) && canViewOnNav(permissions);
};

export const canAccessManagedNavigation = (
  navigation,
  { canAccess },
  fallbackPermission = RESOURCE_SCREEN_PERMISSION
) => canAccess(normalizeNavigationPermissions(navigation, fallbackPermission));

export const filterManagedNavigations = (
  navigations,
  permissions,
  fallbackPermission = RESOURCE_SCREEN_PERMISSION
) => (Array.isArray(navigations) ? navigations : [])
  .filter((navigation) => canRenderManagedNavigation(navigation, permissions, fallbackPermission))
  .map((navigation) => ({
    ...navigation,
    subNavigations: filterManagedNavigations(
      navigation.subNavigations,
      permissions,
      fallbackPermission
    )
  }));
